import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Camera, CheckCircle2, Target, Sparkles } from 'lucide-react';
import { AnimatedSection, AnimatedGrid, AnimatedGridItem } from '../components/AnimatedSection';
const BATHROOM_AFTER = 'https://cdn.magicpatterns.com/uploads/oEgW5paAq2Dk79weiW3TVs/Screenshot_20260602_204021_ChatGPT.jpg';
const BATHROOM_DETAIL = 'https://cdn.magicpatterns.com/uploads/aZCWMbBR6VMR4Qp2JDoydi/IMG_20260602_180800.jpg';
const METER_PANEL_INTERIOR = 'https://cdn.magicpatterns.com/uploads/tjg8zQ9b31BMwXPUfAefb8/Screenshot_20260602_211622_ChatGPT.jpg';
const METER_SERVICE_EXTERIOR = 'https://cdn.magicpatterns.com/uploads/spCvphBURh3V2k7w6Ge8Vp/Screenshot_20260602_211504_ChatGPT.jpg';
const METER_RESIDENTIAL = 'https://cdn.magicpatterns.com/uploads/3vpXh25EbSFYyxLoPqdWiW/Screenshot_20260602_212034_ChatGPT.jpg';
const METER_MOBILE_HOME = 'https://cdn.magicpatterns.com/uploads/gAAHGQLp4PHpsE5eyuUYD6/Screenshot_20260602_212133_ChatGPT.jpg';
const RESIDENTIAL_BEDROOM = 'https://cdn.magicpatterns.com/uploads/neQt3fa1hCVj55jjLBBk7D/Screenshot_20260602_212417_ChatGPT.jpg';
const RESIDENTIAL_KITCHEN = 'https://cdn.magicpatterns.com/uploads/9Zx7UbazjC1hPxTftPBivg/Screenshot_20260602_212447_ChatGPT.jpg';
export function Gallery() {
  const [filter, setFilter] = useState('All');
  const categories = ['All', 'Residential', 'Commercial', 'Panel Upgrades', 'Lighting', 'Service Calls'];
  const projects = [{
    id: 1,
    category: 'Lighting',
    title: 'Custom Bathroom Lighting',
    img: BATHROOM_AFTER
  }, {
    id: 2,
    category: 'Lighting',
    title: 'Bathroom Wall Sconce Detail',
    img: BATHROOM_DETAIL
  }, {
    id: 13,
    category: 'Lighting',
    title: 'Kitchen Lighting Upgrade',
    img: RESIDENTIAL_KITCHEN
  }, {
    id: 14,
    category: 'Lighting',
    title: 'Recessed Bedroom Lighting',
    img: RESIDENTIAL_BEDROOM
  }, {
    id: 10,
    category: 'Panel Upgrades',
    title: 'Meter & Service Installation',
    img: METER_RESIDENTIAL
  }, {
    id: 11,
    category: 'Commercial',
    title: 'Commercial Service Equipment',
    img: METER_SERVICE_EXTERIOR
  }, {
    id: 12,
    category: 'Residential',
    title: 'Mobile Home Power Installation',
    img: METER_MOBILE_HOME
  }];
  const filteredProjects = filter === 'All' ? projects : projects.filter(p => p.category === filter);
  return <div className="w-full" data-id="element-197">
      {/* HERO SECTION */}
      <section className="relative bg-navy text-white py-24 md:py-32 overflow-hidden" data-id="element-198">
        <div className="absolute inset-0 z-0" data-id="element-199">
          <div className="absolute inset-0 bg-navy/90 mix-blend-multiply" data-id="element-200"></div>
          <div className="absolute inset-0 bg-grid-pattern opacity-20" data-id="element-201"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center" data-id="element-202">
          <AnimatedSection data-id="element-203">
            <Camera className="w-12 h-12 text-accent mx-auto mb-6" data-id="element-204" />
            <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold leading-tight tracking-tight mb-6 max-w-4xl mx-auto" data-id="element-205">
              Project <span className="text-accent" data-id="element-206">Gallery</span>
            </h1>
            <p className="text-lg md:text-xl text-slate-300 max-w-2xl mx-auto" data-id="element-207">
              A showcase of our professional electrical installations, upgrades,
              and service calls.
            </p>
          </AnimatedSection>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-2 bg-accent" data-id="element-208"></div>
      </section>

      {/* FEATURED PROJECT */}
      <section className="py-20 md:py-28 bg-white" data-id="element-209">
        <div className="max-w-7xl mx-auto px-6" data-id="element-210">
          <AnimatedSection className="mb-12" data-id="element-211">
            <div className="inline-flex items-center gap-2 bg-yellow-400/10 border border-yellow-400/30 px-3 py-1.5 rounded-full mb-4" data-id="element-212">
              <Sparkles className="w-4 h-4 text-yellow-400" data-id="element-213" />
              <span className="text-sm font-semibold tracking-wider text-yellow-400 uppercase" data-id="element-214">
                Featured Project
              </span>
            </div>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-navy mb-4 tracking-tight" data-id="element-215">
              Residential Lighting Upgrades
            </h2>
            <div className="w-20 h-1.5 bg-accent" data-id="element-216"></div>
          </AnimatedSection>

          {/* Project Images — 4 photo collage */}
          <AnimatedGrid className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-16" data-id="element-217">
            <AnimatedGridItem className="relative aspect-[3/4] overflow-hidden rounded-sm shadow-lg" data-id="element-218">
              <img src={BATHROOM_AFTER} alt="Modern bathroom with custom pendant lighting and wall sconces" className="w-full h-full object-cover" data-id="element-219" />
            </AnimatedGridItem>
            <AnimatedGridItem className="relative aspect-[3/4] overflow-hidden rounded-sm shadow-lg" data-id="element-220">
              <img src={RESIDENTIAL_KITCHEN} alt="Updated kitchen lighting with pendant and recessed fixtures" className="w-full h-full object-cover" data-id="element-221" />
            </AnimatedGridItem>
            <AnimatedGridItem className="relative aspect-[3/4] overflow-hidden rounded-sm shadow-lg" data-id="element-222">
              <img src={RESIDENTIAL_BEDROOM} alt="Bedroom with new recessed ceiling lighting installation" className="w-full h-full object-cover" data-id="element-223" />
            </AnimatedGridItem>
            <AnimatedGridItem className="relative aspect-[3/4] overflow-hidden rounded-sm shadow-lg" data-id="element-224">
              <img src={BATHROOM_DETAIL} alt="Close-up of custom wall sconce lighting" className="w-full h-full object-cover" data-id="element-225" />
            </AnimatedGridItem>
          </AnimatedGrid>

          {/* Description + Services */}
          <div className="grid lg:grid-cols-5 gap-12 mb-16" data-id="element-226">
            <AnimatedSection className="lg:col-span-3" data-id="element-227">
              <h3 className="font-display text-2xl font-bold text-navy mb-4" data-id="element-228">
                Project Description
              </h3>
              <p className="text-lg text-slate-600 leading-relaxed" data-id="element-229">
                This project gallery showcases residential lighting upgrades
                completed by The Electrical Professionals Inc. These projects
                include bathroom lighting, kitchen lighting, recessed lighting,
                wall sconces, fixture replacements, LED lighting upgrades, and
                other interior lighting improvements designed to improve
                comfort, visibility, safety, and home appearance.
              </p>
            </AnimatedSection>

            <AnimatedSection delay={0.2} className="lg:col-span-2" data-id="element-230">
              <div className="bg-navy text-white p-8 rounded-sm relative overflow-hidden h-full" data-id="element-231">
                <div className="absolute inset-0 bg-grid-pattern opacity-5" data-id="element-232"></div>
                <div className="relative z-10" data-id="element-233">
                  <h3 className="font-display text-xl font-bold mb-6" data-id="element-234">
                    Services Included
                  </h3>
                  <ul className="space-y-3" data-id="element-235">
                    {['Bathroom Lighting', 'Kitchen Lighting', 'Recessed Lighting', 'Wall Sconce Installation', 'Fixture Replacement', 'LED Lighting Upgrades', 'Interior Lighting Improvements'].map((service, i) => <li key={i} className="flex items-start gap-3" data-id="element-236">
                        <CheckCircle2 className="w-5 h-5 text-accent shrink-0 mt-0.5" data-id="element-237" />
                        <span className="text-slate-300 text-sm" data-id="element-238">
                          {service}
                        </span>
                      </li>)}
                  </ul>
                </div>
              </div>
            </AnimatedSection>
          </div>

          {/* Project Highlights */}
          <AnimatedSection data-id="element-239">
            <h3 className="font-display text-2xl font-bold text-navy mb-8 text-center" data-id="element-240">
              Project Highlights
            </h3>
            <AnimatedGrid className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-241">
              {['Modern Lighting Solutions', 'Professional Fixture Installation', 'Improved Home Visibility', 'Energy-Efficient Options', 'Clean Finished Appearance', 'Safe, Reliable Workmanship'].map((highlight, i) => <AnimatedGridItem key={i} className="bg-slate-50 border border-slate-100 p-4 rounded-sm text-center" data-id="element-242">
                  <CheckCircle2 className="w-6 h-6 text-accent mx-auto mb-2" data-id="element-243" />
                  <p className="text-sm font-semibold text-navy leading-tight" data-id="element-244">
                    {highlight}
                  </p>
                </AnimatedGridItem>)}
            </AnimatedGrid>
          </AnimatedSection>
        </div>
      </section>

      {/* FEATURED PROJECT — METER & SERVICE INSTALLATION */}
      <section className="py-20 md:py-28 bg-slate-50 border-t border-slate-200" data-id="element-245">
        <div className="max-w-7xl mx-auto px-6" data-id="element-246">
          <AnimatedSection className="mb-12" data-id="element-247">
            <div className="inline-flex items-center gap-2 bg-yellow-400/10 border border-yellow-400/30 px-3 py-1.5 rounded-full mb-4" data-id="element-248">
              <Sparkles className="w-4 h-4 text-yellow-400" data-id="element-249" />
              <span className="text-sm font-semibold tracking-wider text-yellow-400 uppercase" data-id="element-250">
                Featured Project
              </span>
            </div>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-navy mb-4 tracking-tight" data-id="element-251">
              Electrical Service, Meter & Mobile Home Power Installation
            </h2>
            <div className="w-20 h-1.5 bg-accent" data-id="element-252"></div>
          </AnimatedSection>

          {/* Photo collage — 4 images */}
          <AnimatedGrid className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-253">
            <AnimatedGridItem className="relative aspect-[3/4] overflow-hidden rounded-sm shadow-lg md:row-span-2" data-id="element-254">
              <img src={METER_MOBILE_HOME} alt="Mobile home electrical service and meter installation by TEP" className="w-full h-full object-cover" data-id="element-255" />
            </AnimatedGridItem>
            <AnimatedGridItem className="relative aspect-[4/3] overflow-hidden rounded-sm shadow-lg" data-id="element-256">
              <img src={METER_SERVICE_EXTERIOR} alt="Exterior commercial electrical service equipment with conduit installed by TEP" className="w-full h-full object-cover" data-id="element-257" />
            </AnimatedGridItem>
            <AnimatedGridItem className="relative aspect-[4/3] overflow-hidden rounded-sm shadow-lg" data-id="element-258">
              <img src={METER_PANEL_INTERIOR} alt="Interior labeled breaker panel installation" className="w-full h-full object-cover" data-id="element-259" />
            </AnimatedGridItem>
            <AnimatedGridItem className="relative aspect-[4/3] overflow-hidden rounded-sm shadow-lg md:col-span-2" data-id="element-260">
              <img src={METER_RESIDENTIAL} alt="Residential exterior meter and service panel installation" className="w-full h-full object-cover" data-id="element-261" />
            </AnimatedGridItem>
          </AnimatedGrid>

          {/* Description + Services */}
          <div className="grid lg:grid-cols-5 gap-12 mb-16" data-id="element-262">
            <AnimatedSection className="lg:col-span-3" data-id="element-263">
              <h3 className="font-display text-2xl font-bold text-navy mb-4" data-id="element-264">
                Project Description
              </h3>
              <p className="text-lg text-slate-600 leading-relaxed" data-id="element-265">
                This project showcases a professionally completed electrical
                service and meter installation performed by The Electrical
                Professionals Inc. Our team installed and configured electrical
                service equipment, conduit, distribution components, and mobile
                home power connections with a focus on safety, reliability, and
                code-compliant workmanship.
              </p>
            </AnimatedSection>

            <AnimatedSection delay={0.2} className="lg:col-span-2" data-id="element-266">
              <div className="bg-navy text-white p-8 rounded-sm relative overflow-hidden h-full" data-id="element-267">
                <div className="absolute inset-0 bg-grid-pattern opacity-5" data-id="element-268"></div>
                <div className="relative z-10" data-id="element-269">
                  <h3 className="font-display text-xl font-bold mb-6" data-id="element-270">
                    Services Provided
                  </h3>
                  <ul className="space-y-3" data-id="element-271">
                    {['Electrical Service Installation', 'Meter Equipment Installation', 'Mobile Home Electrical Service', 'Mobile Home Power Connections', 'Service Upgrades', 'Conduit Installation', 'Electrical Distribution', 'Safety Testing & Verification'].map((service, i) => <li key={i} className="flex items-start gap-3" data-id="element-272">
                        <CheckCircle2 className="w-5 h-5 text-accent shrink-0 mt-0.5" data-id="element-273" />
                        <span className="text-slate-300 text-sm" data-id="element-274">
                          {service}
                        </span>
                      </li>)}
                  </ul>
                </div>
              </div>
            </AnimatedSection>
          </div>

          {/* Project Highlights */}
          <AnimatedSection className="mb-16" data-id="element-275">
            <h3 className="font-display text-2xl font-bold text-navy mb-8 text-center" data-id="element-276">
              Project Highlights
            </h3>
            <AnimatedGrid className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-7 gap-4" data-id="element-277">
              {['Mobile Home Electrical Expertise', 'Clean Professional Installation', 'Code-Compliant Workmanship', 'Reliable Power Distribution', 'Residential & Commercial Experience', 'Safety-Focused Design', 'Long-Term Reliability'].map((highlight, i) => <AnimatedGridItem key={i} className="bg-white border border-slate-100 p-4 rounded-sm text-center shadow-sm" data-id="element-278">
                  <CheckCircle2 className="w-6 h-6 text-accent mx-auto mb-2" data-id="element-279" />
                  <p className="text-sm font-semibold text-navy leading-tight" data-id="element-280">
                    {highlight}
                  </p>
                </AnimatedGridItem>)}
            </AnimatedGrid>
          </AnimatedSection>

          {/* Benefit & Outcome */}
          <AnimatedGrid className="grid md:grid-cols-2 gap-6" data-id="element-281">
            <AnimatedGridItem className="bg-white border-l-4 border-yellow-400 p-8 rounded-sm shadow-sm" data-id="element-282">
              <div className="flex items-center gap-3 mb-4" data-id="element-283">
                <Target className="w-6 h-6 text-yellow-400" data-id="element-284" />
                <h4 className="font-display font-bold text-xl text-navy" data-id="element-285">
                  Customer Benefit
                </h4>
              </div>
              <p className="text-slate-600 leading-relaxed" data-id="element-286">
                A safe, dependable electrical service installation designed to
                provide reliable power while meeting current electrical
                standards and future electrical needs.
              </p>
            </AnimatedGridItem>

            <AnimatedGridItem className="bg-white border-l-4 border-accent p-8 rounded-sm shadow-sm" data-id="element-287">
              <div className="flex items-center gap-3 mb-4" data-id="element-288">
                <Sparkles className="w-6 h-6 text-accent" data-id="element-289" />
                <h4 className="font-display font-bold text-xl text-navy" data-id="element-290">
                  Outcome
                </h4>
              </div>
              <p className="text-slate-600 leading-relaxed" data-id="element-291">
                The completed installation provides efficient, reliable
                electrical service with a clean and professional appearance that
                reflects our commitment to quality workmanship and customer
                satisfaction.
              </p>
            </AnimatedGridItem>
          </AnimatedGrid>
        </div>
      </section>

      {/* GALLERY SECTION */}
      <section className="py-20 md:py-28 bg-slate-50 border-y border-slate-200" data-id="element-292">
        <div className="max-w-7xl mx-auto px-6" data-id="element-293">
          <AnimatedSection className="text-center max-w-2xl mx-auto mb-12" data-id="element-294">
            <h2 className="font-display text-3xl md:text-4xl font-bold text-navy mb-4 tracking-tight" data-id="element-295">
              More Projects
            </h2>
            <div className="w-20 h-1.5 bg-accent mx-auto" data-id="element-296"></div>
          </AnimatedSection>

          {/* Filters */}
          <AnimatedSection className="flex flex-wrap justify-center gap-3 mb-12" data-id="element-297">
            {categories.map(cat => <button key={cat} onClick={() => setFilter(cat)} className={`px-6 py-2 rounded-full text-sm font-semibold transition-colors ${filter === cat ? 'bg-navy text-white' : 'bg-white text-slate-600 hover:bg-slate-200 border border-slate-200'}`} data-id="element-298">
                {cat}
              </button>)}
          </AnimatedSection>

          {/* Grid */}
          <AnimatedGrid className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-299">
            {filteredProjects.map(project => <AnimatedGridItem key={project.id} className="group relative aspect-[4/3] overflow-hidden rounded-sm bg-slate-100 shadow-sm" data-id="element-300">
                <img src={project.img} alt={project.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-301" />
                <div className="absolute inset-0 bg-navy/80 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col items-center justify-center p-6 text-center" data-id="element-302">
                  <span className="text-yellow-400 text-sm font-bold uppercase tracking-wider mb-2" data-id="element-303">
                    {project.category}
                  </span>
                  <h3 className="text-white font-display text-xl font-bold" data-id="element-304">
                    {project.title}
                  </h3>
                </div>
              </AnimatedGridItem>)}
          </AnimatedGrid>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-white" data-id="element-305">
        <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-306">
          <AnimatedSection data-id="element-307">
            <h2 className="font-display text-3xl md:text-4xl font-bold text-navy mb-6" data-id="element-308">
              Like what you see?
            </h2>
            <p className="text-lg text-slate-600 mb-8" data-id="element-309">
              Let's add your project to our gallery. Contact us today for a free
              estimate.
            </p>
            <Link to="/quote" className="bg-accent hover:bg-accent-hover text-white px-8 py-4 rounded-sm font-bold text-lg transition-colors inline-block" data-id="element-310">
              Request a Free Quote
            </Link>
          </AnimatedSection>
        </div>
      </section>
    </div>;
}